var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isMounted
        ? _c("portal", { attrs: { to: "load_prev" } }, [
            _vm.firstPage > 1
              ? _c(
                  "div",
                  { staticClass: "mt-4 mb-4 text-center" },
                  [
                    !_vm.prevLoading
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-primary trigger-load-prev ml-auto mr-auto",
                            attrs: { disabled: _vm.loading || _vm.prevLoading },
                            on: {
                              click: function($event) {
                                return _vm.loadItems(_vm.firstPage - 1)
                              }
                            }
                          },
                          [
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Weberbuero::Template.loadPrevItems"
                                    )
                                  ) +
                                  "\n                "
                              )
                            ]
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.prevLoading
                      ? _c("loading-animation", {
                          staticClass: "ml-auto mr-auto"
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.prevItems
              ? _c(
                  "div",
                  { staticClass: "product-list row mt-0" },
                  _vm._l(_vm.prevItems, function(item) {
                    return _c(
                      "div",
                      {
                        staticClass:
                          "category-item__col col-6 col-sm-6 col-md-4 col-xxl-3",
                        class: {
                          "col-lg-4": _vm.cols === 3,
                          "col-lg-3": _vm.cols === 4
                        }
                      },
                      [
                        _c("category-item", {
                          key: item.id,
                          attrs: { "item-data": item.data }
                        })
                      ],
                      1
                    )
                  }),
                  0
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "product-list row mt-0" },
        _vm._l(_vm.items, function(item) {
          return _c(
            "div",
            {
              staticClass:
                "category-item__col col-6 col-sm-6 col-md-4 col-xxl-3",
              class: { "col-lg-4": _vm.cols === 3, "col-lg-3": _vm.cols === 4 }
            },
            [
              _c("category-item", {
                key: item.id,
                attrs: { "item-data": item.data }
              })
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.lastPage < _vm.pageMax
        ? _c(
            "div",
            { staticClass: "mt-4 mb-4 text-center" },
            [
              _c("loading-animation", { staticClass: "trigger-load-more mb-5" })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }